// axios基础配置
import axios from 'axios'
import {Message} from 'element-ui'

// let VueEnv = 'development'
let VueEnv = process.env.NODE_ENV
let wOrigin = window.location.origin.split(':')

// 判断是否为本地开发 为本地开发设置静态公共URL  不是就获取动态URL
if (VueEnv === 'development') {
  window.siteUrl = wOrigin[0] + ':' + wOrigin[1] + ':8000'
  axios.defaults.baseURL = '/api'
} else {
  window.siteUrl = window.location.origin
  axios.defaults.baseURL = window.siteUrl
}
axios.defaults.baseURL = window.siteUrl

axios.defaults.withCredentials = true
axios.defaults.timeout = 200000
axios.defaults.crossDomain = true

// 用来取消axios请求
const CancelToken = axios.CancelToken
const source = CancelToken.source()

// axios.defaults.baseURL = ApiUrl;
axios.interceptors.request.use((config) => {
  config.headers['X-Requested-With'] = 'XMLHttpRequest'
  // let name = window.CSRF_COOKIE_NAME || 'csrf_token'
  // let cookieValue = 'NOTPROVIDED'
  // if (document.cookie && document.cookie !== '') {
  //   let cookies = document.cookie.split(';')
  //   for (let i = 0; i < cookies.length; i++) {
  //     let cookie = cookies[i].trim()
  //     // Does this cookie string begin with the name we want?
  //     if (cookie.substring(0, name.length + 1) === (name + '=')) {
  //       cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
  //       break
  //     }
  //   }
  // }
  // config.headers['X-Csrf-Token'] = cookieValue

  config.cancelToken = source.token
  return config
})

axios.interceptors.response.use(response => {
  // console.log(response, source, CancelToken)
  // 登录过期，跳转到登录页面
  console.log(response)
  if (response.status === 401 || (response.data.status === 401 && response.data.to_url)) {
    // console.log(response.data.to_url, source, CancelToken)
    source.cancel('cancle request!')
    window.location.href = response.data.to_url
  } else if (response.status !== 200) {
    Message.error('请求异常，请刷新重试')
    return {
      code: response.status,
      message: '请求异常，请刷新重试',
      result: false
    }
  }
  return response.data
}, error => {
  Message.error('未知错误，请刷新重试')
  return {
    code: 500,
    message: '未知错误，请刷新重试',
    error: error,
    result: false
  }
})

// 发送请求 (接口路径，参数，请求配置)
export function post (url, params, config) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, config).then(
      res => {
        resolve(res)
      },
      err => {
        reject(err)
      }
    )
      .catch(err => {
        reject(err)
      })
  })
}

export function get (url, params, config) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params,
      config: config
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 前后端分离开发时重定向配置
// reUrl = '';  不需要重定向
// export const reUrl = VueEnv === 'production' ? '' : '/api'
export const reUrl = ''



// WEBPACK FOOTER //
// ./src/utils/request.js